import client from 'providers/fetchClient'

export const getParterGlobalDiscount = () =>
  client
    .get('/settings')
    .then(response => +response.data.find(setting => setting.key == 'partner_global_discount')?.value || 0)

export const setPartnerGlobalDiscount = discountValue =>
  client.post('/settings', { key: 'partner_global_discount', value: discountValue })
